import React from 'react';
import styled, { ThemeContext } from 'styled-components';
import { Img } from 'react-image';
import Plx from 'react-plx';
import {
  BigButton, SectionName, SectionTitle, PaddedContainer, buildPlxData,
} from '../common/styles';
import dt, { useIsXLarge } from '../../../shared/theme';

const vPadding = 140;
const Container = styled(PaddedContainer)`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${props => dt(props).theme.isXLarge && `
    flex-direction: row;
    align-items: flex-start;
    padding-top: ${vPadding + 8}px;
    padding-bottom: ${vPadding + 8}px;
    justify-content: space-between;
  `}
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  ${props => (props.theme.isMobile && `
    width: 100%;
  `)};

  ${props => dt(props).theme.isXLarge && `
    width: 31.25vw;
    max-width: 450px;
  `};
`;

const Title = styled(SectionTitle)`
  margin: 20px 0 24px;
`;

const Desc = styled.p`
  margin: 0;
  margin-bottom: 32px;
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightMedium};
  font-size: 20px;
  line-height: 25px;
`;

const Button = styled(BigButton)`
  width: 212px;
`;

const Image = styled(Img)`
  ${props => (dt(props).theme.isXLarge ? `
    width: 560px;
    height: 374px;
  ` : `
    width: 100%;
    margin-top: 48px;
  `)};
`;

function redirectToSolutions(e) {
  if (e) {
    e.preventDefault();
  }
  window.location = '/company/solutions';
}

export default function Purpose() {
  const { purpose } = React.useContext(ThemeContext);
  const plxData = buildPlxData('#purpose-container', vPadding);

  const isXLarge = useIsXLarge();

  return (
    <Container id="purpose-container">
      <Plx parallaxData={plxData.text} disabled={!isXLarge}>
        <Section>
          <SectionName>purpose</SectionName>
          <Title>Livewire is changing the way investors discover investments</Title>
          <Desc>
            We are levelling the playing field by giving all investors access to
            high-value investment insights, commentary and analysis from
            Australia’s leading money managers.
          </Desc>
          <Button onClick={redirectToSolutions}>find out more</Button>
        </Section>
      </Plx>
      <Plx parallaxData={plxData.image} disabled={!isXLarge}>
        <Image src={purpose} />
      </Plx>
    </Container>
  );
}
